'use strict'

module.exports = {
    videoPosterPrefix: 'addPanelData/sections/videos_en/fullWidthGalleries/gallery-video-thumb-fullwidth-',
    videoSrcPrefix: 'gallery-video-thumb-fullwidth-'
}